import { CashDiscrepancyReport } from '../../../types';
import { commonColProps, DataGridHandler } from '../../DataGridFlexSales';

export interface CashDiscrepancyReportDataGridContext {
  t: (key: string | string[]) => string;
  country: string;
}

const initialContext: CashDiscrepancyReportDataGridContext = {
  t: () => '',
  country: '',
};

export default (locale: Locale) => {
  const handler = new DataGridHandler<CashDiscrepancyReport, CashDiscrepancyReportDataGridContext>(
    initialContext,
    locale
  );

  handler.addColumn({
    accessor: 'country',
    type: 'string',
    title: ({ t }) => t('table.columns.country'),
    ...commonColProps.country,
  });

  handler.addColumn({
    accessor: 'store',
    type: 'string',
    title: ({ t, country }) => t([`table.columns.${country}.store`, 'table.columns.store']),
  });

  handler.addColumn({
    accessor: 'franchiseType',
    type: 'string',
    title: ({ t }) => t(['toolbar.labels.franchiseType']),
    width: { px: 100, pt: 100 },
  });

  handler.addColumn({
    accessor: 'month',
    type: 'date',
    title: ({ t }) => t('table.columns.month'),
    ...commonColProps.month,
  });

  handler.addColumn({
    accessor: 'tenderName',
    type: 'string',
    title: ({ t }) => t('table.columns.tender_name'),
  });

  handler.addColumn({
    accessor: 'account',
    type: 'string',
    title: ({ t }) => t('accounting-info-report.columns.account'),
  });

  handler.addColumn({
    accessor: 'excess',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.cash-discrepancy.columns.excess'),
  });

  handler.addColumn({
    accessor: 'enteredDr',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.cash-discrepancy.columns.entered-dr'),
  });

  handler.addColumn({
    accessor: 'enteredCr',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.cash-discrepancy.columns.entered-cr'),
  });

  handler.addColumn({
    accessor: 'accountedDr',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.cash-discrepancy.columns.accounted-dr'),
  });

  handler.addColumn({
    accessor: 'accountedCr',
    type: 'number',
    title: ({ t }) => t('accounting-info-report.cash-discrepancy.columns.accounted-cr'),
  });

  return handler;
};
